const categorySlugFinder: Record<string, string> = {
  CBD: "cbd",
  Canada: "canada",
  "Cannabis 101": "cannabis-101",
  Growing: "growing",
  Health: "health",
  Industry: "industry",
  "Leafly List": "leafly-list",
  Lifestyle: "lifestyle",
  Podcasts: "podcasts",
  Politics: "politics",
  "Science & tech": "science-tech",
  "Strains & products": "strains-products",
};

export const categorySlug = (categoryName: string) => {
  const slug = categorySlugFinder[categoryName];

  if (slug) {
    return categorySlugFinder[categoryName];
  }

  return null;
};
